'use client';
import styled from 'styled-components';

import { Spacers } from '@styles/theme';

import { StyledChevron } from '@components/Common';
import { HeaderContainerProps, LogoContainerProps } from '@components/Header/interfaces';

export const HeaderContainer = styled.header<HeaderContainerProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: ${(props) => props.$isMenuOpen && 'none'};
  line-height: 0;
`;

export const IconContainer = styled.div`
  width: ${Spacers.LG}rem;
  padding-block: ${Spacers.BASE}rem;
`;

export const IconContainerButton = styled.button`
  color: ${({ theme }) => theme.colors.typographyHeadersLight};
  padding-block: ${Spacers.BASE}rem;
  cursor: pointer;
  border: none;
  line-height: 0;
  &:hover {
    color: ${(props) => props.theme.colors.actionDefault};

    ${StyledChevron} {
      color: ${(props) => props.theme.colors.actionDefault};
    }
  }
`;

export const IconContainerLink = styled.a`
  color: ${({ theme }) => theme.colors.typographyBodyLight};
  padding-block: ${Spacers.BASE}rem;
  cursor: pointer;
`;

export const LogoContainer = styled.button<LogoContainerProps>`
  padding-block: 1.188rem;
  cursor: ${(props) => (props.$isClickable !== false ? 'pointer' : 'default')};
  border: none;
  background: none;
  line-height: 0;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: ${(props) => (props.$isClickable !== false ? '0.7' : '1')};
  }
`;
